import { Component } from 'react'
import styled from '@emotion/styled'
import { Box, EncodingUserCountersOrderRowData } from 'stylewhere/components'
import { T, __ } from 'stylewhere/i18n'
import { OrderUserCountersRow, OrderUserColumn } from 'stylewhere/api'
import { buildGridTemplate } from 'stylewhere/shared/utils'

interface Props {
  rows: OrderUserCountersRow[]
  orderIndex: number
}

export class EncodingUserCountersOrderRow extends Component<Props> {
  getColumns = () => {
    const columns: OrderUserColumn[] = [
      { label: __(T.misc.production_order_row), field: 'rowCode', flex: true },
      { label: __(T.misc.product), isProductCode: true, maxWidth: 200, flex: true },
      { label: __(T.misc.style), field: 'style', isProductAttribute: true, maxWidth: 150, flex: true },
      { label: __(T.misc.material), field: 'material', isProductAttribute: true, maxWidth: 180, flex: true },
      { label: __(T.misc.color), field: 'color', isProductAttribute: true, maxWidth: 200, flex: true },
      { label: __(T.misc.size), field: 'size', isProductAttribute: true, maxWidth: 100, flex: true },
      {
        label: __(T.misc.encodings),
        field: 'encodings',
        maxWidth: 120,
        flex: true,
        center: true
      },
      { label: __(T.misc.progress), maxWidth: 120, flex: true, center: true, progress: true }
    ]
    return columns
  }

  render() {
    const { rows, orderIndex } = this.props
    const columns = this.getColumns()
    const gridStyle = {
      display: 'grid',
      gridTemplateColumns: buildGridTemplate(columns)
    }
    return (
      <Box flex mt={20} ml={38}>
        <IntestazioneRow row ml={0} mr={0} style={gridStyle}>
          {columns.map((col, i) => {
            return (
              <Intestazione key={'head-col-' + i} center={col.center ?? false} last={i === columns.length - 1}>
                {col.label}
              </Intestazione>
            )
          })}
        </IntestazioneRow>
        {rows?.map((item, index) => {
          return (
            <EncodingUserCountersOrderRowData
              key={'row-' + orderIndex + '-' + index}
              row={item}
              rowIndex={index}
              rowsCount={rows.length}
              columns={columns}
              orderIndex={orderIndex}
            />
          )
        })}
      </Box>
    )
  }
}

const IntestazioneRow = styled(Box)`
  overflow: hidden;
  display: flex;
  flex-direction: row;
`

const Intestazione = styled(Box)<{ last?: boolean }>`
  padding-right: ${(props) => (props.last ? '0px' : '15px')};
  color: #454545;
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  justify-content: center;
`

const ItemRow = styled(Box)<{ last?: boolean }>`
  border: 0px;
`

const ItemColumn = styled(Box)<{ last?: boolean }>`
  padding-right: ${(props) => (props.last ? '0px' : '15px')};
  color: #454545;
  font-weight: 300;
  font-size: 20px;
  line-height: 24px;
  justify-content: center;
`
